module.exports = __webpack_public_path__ + "img/amio_chat.2b0d2a44.svg";